import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { createMavenirConfigs } from '@api/dataSources';

import { TMavenirConfigsCreateDTO } from '@interfaces/cmModule/dto/dataSourceDTO';

import { ESnackbarTypes } from '@enums/common';

import { MAVENIR_CONFIG_CREATE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IMavenirConfigCreateReturnType {
	createConfig: (dto: TMavenirConfigsCreateDTO) => void;
	isLoadingCreateMavenirConfig: boolean;
}

export function useMutateMavenirConfigCreate(onSuccessHandler?: () => void): IMavenirConfigCreateReturnType {
	const dispatch = useAppDispatch();

	const {
		mutate: createConfig,
		isLoading: isLoadingCreateMavenirConfig,
	} = useMutation<TMavenirConfigsCreateDTO>({
		mutationKey: [MAVENIR_CONFIG_CREATE],
		mutationFn: createMavenirConfigs,
		onSuccess: () => {
			if (onSuccessHandler) onSuccessHandler();

			dispatch(setSnackbar({
				message: responseMessages.uploadDataSourcesConfig,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		createConfig,
		isLoadingCreateMavenirConfig,
	};
}
